import _ from 'lodash'
import fetch from '@adc/fetch'
import { ListingCard, utils, constants } from '@adc/ui-adc'
import { gql } from '@adc/sdk'

const { symbols } = utils
const LISTING_CARDS_REFERENCE =
  ListingCard[symbols.GRAPH_API_FRAGMENT_REFERENCE]
const LISTING_CARDS_FRAGMENT =
  ListingCard[symbols.GRAPH_API_FRAGMENT_DEFINITION]

const stateLookup = _.keyBy(constants.optionLists.states, state =>
  state.value.toLowerCase()
)

export const fetchEventListings = (req, params) => {
  // These are currently no supported by the graph compat filters type
  const { hasAuthenticatedUser } = params
  const supportedGraphFilters = _.omit(params, [
    'auction_id',
    'fields',
    'hasAuthenticatedUser',
  ])

  return fetch
    .forAuctionGraph(
      {
        query: gql`
        ${LISTING_CARDS_FRAGMENT}

        query resiEvent_listingsForEvent(
          $filters: ListingCompatabilityFilters!,
          $hasAuthenticatedUser: Boolean!
        ) {
          seek_listings_from_filters(filters: $filters) {
            total_count
            size
            content {
              ... on Listing {
                listing_id
                ${LISTING_CARDS_REFERENCE}
              }
            }

            aggregation(fields: [
              "listing_status.keyword",
              "properties.summary.address.country_primary_subdivision",
              "properties.summary.address.country_secondary_subdivision",
              "properties.summary.address.municipality",
            ])
          }
        }
      `,
        variables: {
          hasAuthenticatedUser,
          filters: {
            ...supportedGraphFilters,

            // We always need to specify this per the Graph API design
            version: 1,
          },
        },
      },
      { req }
    )
    .then(({ body }) => {
      const data = body.data?.seek_listings_from_filters || { content: [] }

      // NOTE: We map this aggregation mapping inside the provider since only the provider knows exactly what fields we
      // are aggregating on and we don't want to couple anything else to that field format
      if (data.aggregation) {
        const appAggregationFormat = {
          listing_status: _.mapKeys(
            data.aggregation['listing_status.keyword_count'] || {},
            (val, key) => key.toUpperCase()
          ),
          location: {
            states: data.aggregation[
              'properties.summary.address.country_primary_subdivision'
            ]
              .sort()
              .map(state => ({
                value: stateLookup[state.toLowerCase()]?.value,
                label: stateLookup[state.toLowerCase()]?.text,
              })),
            counties: data.aggregation[
              'properties.summary.address.country_secondary_subdivision'
            ]
              .sort()
              .map(county => ({
                value: county,
                label: _.startCase(county),
              })),
            cities: data.aggregation['properties.summary.address.municipality']
              .sort()
              .map(city => ({
                value: city,
                label: _.startCase(city),
              })),
          },
        }

        data.aggregation = appAggregationFormat
      } else {
        data.aggregation = {
          listing_status: {},
          location: {
            states: [],
            counties: [],
            cities: [],
          },
        }
      }

      return data
    })
}
